import React, { Component } from 'react';
import { request } from 'http';
import Q from './shared/Q'
import MySlider from './shared/MySlider'

export default class Head extends Component {
	state={value:10}
	onAns(value) {
		this.setState({value})
	}
	render() {
		const {t,l} = this.props
		const {value} = this.state
		return <Q q="How many apps do you have right now on your current Smartphone?" {...this.props}>
			<MySlider style={{
				position:"absolute",
				top:200,
				left:60
			}} value={value} txt="apps" min={0} max={100} cb={value => this.setState({value})}/>

		</Q>	
	}
}



// WEBPACK FOOTER //
// ./src/dComp/HowManyApps.js